import retinajs from 'retinajs';
import * as THREE from 'three';

// Tableau
const Tabtextures = [["a"],["b"],["c"],["d"],["e"],["f"],["g"],["h"],["i"],["j"],["k"],["l"],["m"],["n"],["o"],["p"],["q"],["r"],["s"],["t"],["u"],["v"],["w"],["x"],["y"],["z"]];

var keyPressed = false;
function keyListener(event){
    
    event.preventDefault();
    switch( event.code ) {
        case "ArrowUp": 
            camera.position.y += 0.3;
        break;

       case "ArrowDown":
            camera.position.y -= 0.3;
        break;
        case "ArrowLeft":
            camera.position.x -= 0.3;
        break;
        case "ArrowRight":
            camera.position.x += 0.3;
        break;
    }

}
function zoom(event) {
    scale+= event.deltaY * -0.01;
    scale = Math.min(Math.max(1, scale), 12);
    camera.position.z = scale;
    console.log(scale)
}
let scale = 1;
document.body.onwheel = zoom;
            const scene = new THREE.Scene();
            const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
            const renderer = new THREE.WebGLRenderer({antialias: true});
            renderer.setSize( window.innerWidth , window.innerHeight );
			document.body.appendChild( renderer.domElement );
            document.body.addEventListener("keydown", keyListener, false);
            camera.position.set(6,-2.5,6);

            let i = 0;
            for(let cube in Tabtextures) {
                const geometry = new THREE.BoxGeometry();
                const texture = new THREE.TextureLoader().load("../assets/images/lettres/"+ Tabtextures[cube] + ".jpg");
                const material = new THREE.MeshBasicMaterial( { map: texture } );
                Tabtextures[cube] = new THREE.Mesh(geometry, material);

                if(i < 7) {
                Tabtextures[cube].position.x = cube*2;
                }
                if(i >= 7) {
                    let ligne = cube*2 - 14;
                    Tabtextures[cube].position.y = -2;
                    Tabtextures[cube].position.x =ligne;
                }
                if(i > 13) {
                    let ligne = cube*2 - 28;
                    Tabtextures[cube].position.y = -4;
                    Tabtextures[cube].position.x =ligne;
                }
                if(i > 20 ) {
                    let ligne = cube*2 - 42;
                    Tabtextures[cube].position.y = -6;
                    Tabtextures[cube].position.x =ligne;
                }
                scene.add(Tabtextures[cube]);
                i++;
        
            }
			const animate = function () {
                requestAnimationFrame( animate );

                for(let cubes in Tabtextures) {
                   //Tabtextures[cube].rotation.x += 0.01;
                  // TabTexture[cubes].rotation.y += 0.01;
    
                    renderer.render( scene, camera );
                }

			};

            animate();


// Resize
window.addEventListener( 'resize', onWindowResize, false );

function onWindowResize(){

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();

    renderer.setSize( window.innerWidth, window.innerHeight );

}